/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * @param market
 * @param status
 * @param side
 * @param size
 * @param maxSize
 * @param entryPrice
 * @param realizedPnl
 * @param createdAt
 * @param createdAtHeight
 * @param sumOpen
 * @param sumClose
 * @param netFunding
 * @param unrealizedPnl
 * @param closedAt
 * @param exitPrice
 * @param subaccountNumber
 */
@JsExport
@Serializable
data class IndexerPerpetualPositionResponseObject(

    val market: kotlin.String? = null,
    val status: IndexerPerpetualPositionStatus? = null,
    val side: IndexerPositionSide? = null,
    val size: kotlin.String? = null,
    val maxSize: kotlin.String? = null,
    val entryPrice: kotlin.String? = null,
    val realizedPnl: kotlin.String? = null,
    val createdAt: IndexerIsoString? = null,
    val createdAtHeight: kotlin.String? = null,
    val sumOpen: kotlin.String? = null,
    val sumClose: kotlin.String? = null,
    val netFunding: kotlin.String? = null,
    val unrealizedPnl: kotlin.String? = null,
    val closedAt: IndexerIsoString? = null,
    val exitPrice: kotlin.String? = null,
    val subaccountNumber: kotlin.Int? = null
)
